import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  Button,
  Switch,
} from "@material-ui/core";
import { Visibility } from "@material-ui/icons";

import Visa from "../../../../Assets/PaymentGateways/Visa.png";
import AmericanExpress from "../../../../Assets/PaymentGateways/AmericanExpress.png";
import Discover from "../../../../Assets/PaymentGateways/Discover.jpg";
import Mastercard from "../../../../Assets/PaymentGateways/Mastercard.png";
import { PrimaryButton } from "../../../../Shared/Buttons";
import GatewayModal from "./GatewayModal";
import GatewayDeleteButton from "./GatewayDeleteButton";
import OpenSnackbar from "../../../../Shared/OpenSnackbar";

const iconArr = [AmericanExpress, Discover, Mastercard, Visa];

const PaymentGatewayComp = ({ classes, settings, setSettings }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState("");
  const [item, setItem] = useState(null);
  const [ItemIndex, SetItemIndex] = useState(undefined);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    type: "",
    message: "",
  });

  const handleOpen = (item, localAction, Index) => {
    if (item) {
      setItem(item);
      SetItemIndex(Index);
    } else {
    }
    setAction(localAction);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setItem(null);
  };

  const handleGatewayChange = (gateway, item, localAction) => {
    switch (localAction) {
      case "Add": {
        let generalSettings = settings?.generalSettings;
        setOpenSnackbar(true);
        setSnackbar({
          type: "successDark",
          message: "gateway added successfully",
        });
        generalSettings?.gateway_info.push(gateway);
        setSettings({
          ...settings,
          generalSettings: generalSettings,
        });
        handleClose();
        return;
      }
      case "Edit": {
        let generalSettings = settings?.generalSettings;
        console.log("generat setting >",generalSettings.gateway_info);
        let localIndex = ItemIndex
        generalSettings.gateway_info[--localIndex] = gateway;

        console.log("index", ItemIndex);
        console.log(gateway);
        console.log(generalSettings);
        setSettings({ ...settings, generalSettings: generalSettings });
        handleClose();
        setOpenSnackbar(true);

        setSnackbar({
          type: "successDark",
          message: "gateway updated successfully",
        });
        return;
      }
      default:
        return;
    }
  };
  const handleDeleteCharge = (index) => {
    index = --index;
    let obj = settings.generalSettings;
    let arr = obj.gateway_info.filter((_,localIndex) =>localIndex !== index );
    console.log("this is arr",arr);
    obj.gateway_info = arr;
    setSettings({ ...settings, generalSettings: obj });
    setOpenSnackbar(true);

    setSnackbar({
      type: "successDark",
      message: "gateway deleted successfully",
    });
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    let obj = settings?.paymentSettings;
    obj.payment_types[name] = checked;
    setSettings({ ...settings, paymentSettings: obj });
  };

  const maskPass = (password, value) => {
    const vis = password.slice(-value);
    let countNum = "";

    for (var i = password.length - value; i > 0; i--) {
      countNum += "*";
    }
    const maskPass = countNum + vis;
    return maskPass;
  };

  const handleIconChange = (e) => {
    const { name, checked } = e.target;
    let obj = settings?.paymentSettings;
    obj.cards_accepted[name] = checked;
    setSettings({ ...settings, paymentSettings: obj });
  };

  let stateArr = [];

  useEffect(() => {
    settings?.generalSettings?.gateway_info &&
      settings?.generalSettings?.gateway_info.map((item) => {
        stateArr.push(false);
      });
  }, [handleGatewayChange]);

  const [show, setShow] = useState(stateArr);

  const handleVisible = (index, value) => {
    let obj = show;
    obj[index] = !value;
    setShow([...obj]);
  };

  const handleDefaultGateway = (e, index) => {
    index = --index;
    const { checked, name } = e.target;
    let obj = settings.generalSettings;
    obj.gateway_info[index][name] = checked;
    if (checked === true) {
      obj.gateway_info = obj.gateway_info.map((value, idx) => {
        if (idx != index) {
          value[name] = false;
        }
        return value;
      });
    }
    setSettings({ ...settings, generalSettings: obj });
  };

  return (
    <>
      <Grid item xs={12} className={classes.mt40}>
        <Typography variant="h5" className={classes.typographyStyles}>
          Gateway Settings
        </Typography>
        <hr />

        <Grid item xs={12} className={classes.mt30}>
          <Typography variant="h5" className={classes.typographyStyles}>
            Payment Gateway
          </Typography>
          {settings?.generalSettings?.gateway_info &&
            settings?.generalSettings?.gateway_info.map((item, index) => {
              return (
                <div style={{ margin: "1rem auto" }}>
                  <Typography variant="h6" className={classes.typographyStyles}>
                    Gateway {++index}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      width: "13%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() => handleOpen(item, "Edit", index)}
                      data-testid={`edit_gateway_${item.customer_code}`}
                    >
                      Edit
                    </Button>
                    <GatewayDeleteButton
                      index={index}
                      classes={classes}
                      user_name={item.user_name}
                      handleDeleteCharge={handleDeleteCharge}
                    />
                  </div>
                   
                  <Typography
                    variant="body1"
                    // style={{ marginLeft: "2rem" }}
                    className={classes.typographyStyles}
                  >
                    Customer Code: {item.customer_code}
                  </Typography>
                  <Typography
                    variant="body1"
                    // style={{ marginTOP: "2rem" }}
                    className={classes.typographyStyles}
                  >
                    Processor Name: {item.processor_name}
                  </Typography>
                  <Typography
                    variant="body1"
                    // style={{ marginLeft: "2rem" }}
                    className={classes.typographyStyles}
                  >
                    Username: {item.user_name}
                  </Typography>
                  <div style={{ display: "flex" }}>
                    <Typography
                      variant="body1"
                      // style={{ marginLeft: "2rem" }}
                      className={classes.typographyStyles}
                    >
                      Password:
                      {show[index] === true
                        ? item.password
                        : maskPass(item.password, 4)}
                    </Typography>
                    <Visibility
                      onClick={() => handleVisible(index, show[index])}
                      style={{
                        cursor: "pointer",
                        margin: "0 10px",
                      }}
                    />
                  </div>
                  <FormControl>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            name="in_use"
                            color="primary"
                            checked={item.in_use}
                            className={classes.checkboxStyles}
                            onChange={(e) => handleDefaultGateway(e, index)}
                            inputProps={{
                              "aria-label": `in_use_gateway_switch_${item.customer_code}`,
                            }}
                          />
                        }
                        key="in_use"
                        label={
                          <Typography
                            variant="body1"
                            className={classes.typographyStyles}
                          >
                            In Use
                          </Typography>
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </div>
              );
            })}
          <PrimaryButton
            style={{ marginTop: "20px" }}
            handleClick={() => handleOpen(undefined, "Add")}
            testId={`add_gateway_btn`}
          >
            Add Gateway
          </PrimaryButton>
        </Grid>
        {isOpen && (
          <GatewayModal
            classes={classes}
            isOpen={isOpen}
            handleClose={handleClose}
            action={action}
            setIsOpen={setIsOpen}
            item={item}
            handleGatewayChange={handleGatewayChange}
          />
        )}

        {snackbarOpen && (
          <OpenSnackbar
            message={"Gateway already exist"}
            type={"errorDark"}
            open={snackbarOpen}
            setOpen={setSnackbarOpen}
            vertical="bottom"
            horizontal="left"
          />
        )}
        <OpenSnackbar
          open={openSnackbar}
          setOpen={setOpenSnackbar}
          message={snackbar.message}
          type={snackbar.type}
          vertical="bottom"
          horizontal="center"
        />
      </Grid>

      <Grid item xs={12} className={classes.mt30}>
        <Typography variant="h5" className={classes.typographyStyles}>
          Payment Method
        </Typography>
        <FormControl>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    settings?.paymentSettings?.payment_types["pay_by_cash"] ||
                    false
                  }
                  name="pay_by_cash"
                  onChange={handleChange}
                  color="primary"
                  className={classes.checkboxStyles}
                  inputProps={{
                    "aria-label": "pay_by_cash_check",
                  }}
                />
              }
              key="pay_by_cash"
              label={
                <Typography
                  variant="body1"
                  className={classes.typographyStyles}
                >
                  Pay By Cash
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  disabled={settings?.generalSettings?.gateway_info.length===0}
                  checked={
                    settings?.paymentSettings?.payment_types["pay_by_card"] ||
                    false
                  }
                  name="pay_by_card"
                  onChange={handleChange}
                  color="primary"
                  className={classes.checkboxStyles}
                  inputProps={{
                    "aria-label": "pay_by_card_check",
                  }}
                />
              }
              key="pay_by_card"
              label={
                <Typography
                  variant="body1"
                  className={classes.typographyStyles}
                >
                  Pay By Card
                </Typography>
              }
            />
          </FormGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12} className={classes.mt20}>
        <Typography variant="body1" className={classes.typographyStyles}>
          Accepted Cards
        </Typography>

        <Paper square elevation={0} className={classes.paperStyleIcons}>
          {settings?.paymentSettings?.cards_accepted &&
            Object.keys(settings.paymentSettings.cards_accepted).map(
              (item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      disabled={settings?.generalSettings?.gateway_info.length===0}
                      checked={settings.paymentSettings.cards_accepted[item]}
                      onChange={handleIconChange}
                      name={item}
                      color="primary"
                      className={classes.checkboxStyles}
                      inputProps={{
                        "aria-label": `card_${item}`,
                      }}
                    />
                  }
                  label={
                    <img
                      src={iconArr[index]}
                      alt={item}
                      style={{ width: 100 }}
                    />
                  }
                />
              )
            )}
        </Paper>
      </Grid>
    </>
  );
};

export default PaymentGatewayComp;
